import React from 'react';
import Carousel from 'react-instagram-carousel';
import "./storyslider.scss"
import {choosedFile} from "../../dropzone/multiselect/multielectdropzone";

interface IStorySlider {
    selectedFiles: choosedFile[]
}

const images: string[] = [
    require("../../../assets/images/photos/Person4.png"),
    require("../../../assets/images/photos/Person3.png"),
];


const StorySlider = ({selectedFiles}: IStorySlider) => {
    return (
        <div className="Story-Slider">
            <div className="Story-Slider-User">
                <img src={require("../../../assets/images/avatars/Avatar7.png")} alt="" className="img-fluid"/>
                <span>vidomovoe</span>
            </div>
            <Carousel images={selectedFiles.map(selectedFile => selectedFile.url)}
                      nextMsec={3000}
                      speed={20}
                      barHeight={3}
                      backgroundSize={'contain'}
                      backgroundColor={'black'}/>
            <div className="Story-Slider-Actions w-100">
                <input type="text" name="" id="" className="Story-Input" placeholder="Send message ..."/>
                <img src={require("../../../assets/images/icons/LikeLight.svg").default} alt="" className="img-fluid"/>
                &nbsp;&nbsp;
                <img src={require("../../../assets/images/icons/ShareLight.svg").default} alt="" className="img-fluid"/>
            </div>
        </div>
    );
}

export default StorySlider;